import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import Button from 'components/button'
import TextInput from 'components/setupform-form/field/text-input'

import styles from './venue-search-new-input.css'

const VenueSearchNewInput = ({ clearNewVenue, venueAddressData, venueNameData }) => (
  <div styleName="new-input">
    <div styleName="help-text">Please provide us with some details of the venue:</div>
    <div styleName="field"><TextInput data={venueNameData} placeholder="Name" /></div>
    <div styleName="field"><TextInput data={venueAddressData} placeholder="Address" /></div>
    <div styleName="cancel"><Button text="Go back to search" type="utility" onClick={clearNewVenue} /></div>
  </div>
)

VenueSearchNewInput.propTypes = {
  clearNewVenue: PropTypes.func,
  venueAddressData: PropTypes.object,
  venueNameData: PropTypes.object,
}

export default CSSModules(VenueSearchNewInput, styles)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/venue-search/venue-search-new-input/venue-search-new-input.js
 **/